module.exports = "../study/imgs/maps/Kanagawa/S8/Hazard/Slopefailure/Kanagawa_Slopefailure_GFDL_RCP26_End.png";